"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Snackbar.default;
  }
});
Object.defineProperty(exports, "SnackbarContent", {
  enumerable: true,
  get: function get() {
    return _SnackbarContent.default;
  }
});

var _Snackbar = _interopRequireDefault(require("./Snackbar"));

var _SnackbarContent = _interopRequireDefault(require("./SnackbarContent"));


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/Snackbar/index.js
// module id = 343
// module chunks = 35783957827783 70144966829960 114276838955818